<template lang="pug">
div.mb-0.pb-0.main-container
  v-layout(column align-center justify-center)
    h1.stepper-title Welcome
      span  {{user.first_name}}
      | !
    h1.stepper-title How will you use LionDesk?
    p.stepper-subtitle.mb-0.mt-2 Check all that apply.
  v-layout.pa-3(wrap row justify-center)
    v-card.mx-3.pa-4.elevation-3(:class="checkCard1 ? 'content-card content-card--checked' : 'content-card'")
      v-layout(column align-center justify-center fill-height)
        v-flex.pa-0.card-title-container(xs3)
          v-checkbox.pa-0.ma-0(
            color="orange accent-3" 
            :class="checkCard1 ? 'card-checkbox--checked' : 'card-checkbox'" 
            :on-icon="'check_box'" 
            :off-icon="'check_box_outline_blank'" 
            type="checkbox" 
            v-model="checkCard1"
          )
          p.pa-0.ma-0.card-title Generate and Manage New Leads
        v-icon.mt-4.csv-upload-icon(color="orange accent-3") person_add              
    v-card.mx-3.pa-4.elevation-3(:class="checkCard2 ? 'content-card content-card--checked' : 'content-card'")
      v-layout(column align-center justify-center fill-height)
        v-flex.pa-0.card-title-container(xs3)
          v-checkbox.pa-0.ma-0(
            color="orange accent-3" 
            :class="checkCard2 ? 'card-checkbox--checked' : 'card-checkbox'" 
            :on-icon="'check_box'" 
            :off-icon="'check_box_outline_blank'" 
            type="checkbox" 
            v-model="checkCard2"
          )
          p.pa-0.ma-0.card-title Stay Top of Mind with My Past Clients
        v-icon.mt-4.csv-upload-icon(color="orange accent-3") notifications_active            
    v-card.mx-3.pa-4.elevation-3(:class="checkCard3 ? 'content-card content-card--checked' : 'content-card'")
      v-layout(column align-center justify-center fill-height)
        v-flex.pa-0.card-title-container(xs3)
          v-checkbox.pa-0.ma-0(
            color="orange accent-3" 
            :class="checkCard3 ? 'card-checkbox--checked' : 'card-checkbox'" 
            :on-icon="'check_box'" 
            :off-icon="'check_box_outline_blank'" 
            type="checkbox" 
            v-model="checkCard3"
          )
          p.pa-0.ma-0.card-title Nurture My Sphere of Influence (SOI)
        v-icon.mt-4.csv-upload-icon(color="orange accent-3") supervised_user_circle
  v-container.mb-0.pb-0
    v-layout.mb-0.pb-0(column align-center justify-center)
      v-btn.ma-0.text-uppercase.action-btn.primary(@click='setStepperStage(2)') Continue
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'OnboardingStep1',
  data() {
    return {
       checkCard1: false,
       checkCard2: false,
       checkCard3: false,
    };
  },
  methods: {
      ...mapActions('onboarding', [
        'updateOnboardingUses',
      ]),
    setStepperStage(value) {
      this.$emit('click:change', value); 
      this.handleOnboardingUses();     
    },
    handleOnboardingUses(){
      this.updateOnboardingUses(this.cardsSelected);
    }
  },
  computed: {
    ...mapState('userInformation', ['user']),
    cardsSelected() {
      let uses = [];
      if (this.checkCard1) uses.push(1);
      if (this.checkCard2) uses.push(2);
      if (this.checkCard3) uses.push(3);
      return uses;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 70vh;
}
.stepper-title {
  font-size: 36px;
  font-weight: 500;
  line-height: 1.1;
  color: var(--v-primary-base);
}
.stepper-subtitle {
  font-size: 20px;
}
.content-card {
  cursor: pointer;
  border-radius: 10px;
  min-height: 310px;
  width: 300px;
  &--bigger {
    height: 400px;
  }
  &--checked {
    border: 2px solid #FF9100;
    border-radius: 10px;
  }
}
.card-checkbox{
  transform: scale(0.8);
  &--checked{
    transform: scale(0.8);
  }
}
.card-title-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  height: auto;
}
.input{
  transform: scale(0.8);
}
.card-title {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 205px;
  color: rgba(0, 0, 0, 0.87);
  &--xs {
    font-size: 18px;
    width: 250px;
  }
}
.csv-upload-icon {
  font-size: 80px;
}
.continue-btn {
  font-size: 20px;
}
.skip-btn {
  font-size: 15px;
  margin-top: 0;
  color: var(--v-primary-lighten2);
}
.action-btn {
  font-size: 18px;
}
</style>
